import { getTypeApi } from "../api/taxonomy";
import {fetchPurposeApi} from "../api/PurposeType"
import {fetchDonationTypeApi} from "../api/DonationTypes";
import { addDonationTPApi } from "../api/DonationTypePurpose";
import { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { redirect, useNavigate } from "react-router-dom";

type DonationTypePurpose = {
  id: string;
  Id: string;
  type: string;
  purpose: string;
  value: string;
  parentId: string | null;
};
type PurposeType = {
  id: string;
  name: string;
  parentId: string | null;
  isHiddenForUser: boolean;
}

interface DonationTypePurposeformProps {
  url: string;
    onClose: () => void;
}
export const DonationTypePurposeForm = ({
  url,
  onClose,
}: DonationTypePurposeformProps) => {
  const [type, setDonationType] = useState<string | null>(null);
  const [purpose, setPurpose] = useState<string | null>(null);
  const [dataPurpose, setDataPurpose] = useState<PurposeType[]>([]);
  const [dataType, setDataType] = useState<PurposeType[]>([]);

  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetchDonationTypeApi(url);
        setDataType(response);
        const res = await fetchPurposeApi( url) as PurposeType[];
        setDataPurpose(res);
      } catch (error) {
        console.error("Error fetching Data:", error);
      }
    };
    fetchData();
  }, []);

  const filteredPurpose = dataPurpose.filter(
    (item) =>item.parentId === null
   
  );


  const handleSubmitClick = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();

    if (!type || !purpose) {
      toast.success("Please fill all the fields");
      return;
    }

    try {
      await addDonationTPApi(type, purpose, url);
      toast.success("Added Successfully");
      redirect("/admin/DonationTypePurpose");
    } catch (error) {
      toast.error("Failed to process");
      console.error("Error during submission:", error);
    }

    handleResetForm();
  };

  const handleResetForm = () => {
    setDonationType(null);
    setPurpose(null);
    onClose();
  };

  return (
    <div className="">
      <div className="text-3xl font-bold text-blue-600 mb-5 mt-5">
        <p>Add New Donation Type Purpose</p>
      </div>
      <form onSubmit={handleSubmitClick} className="mt-8 space-y-4">
        <div className="flex flex-col space-y-2">
          <label className="font-medium text-black dark:text-gray-200">
            Donation Type
          </label>
          <select
            className="p-2 border border-gray-300 rounded-lg text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-400 focus:border-blue-500"
            value={type || ""}
            required
            onChange={(e) => {
              setDonationType(e.target.value);
              setPurpose("");
            }}
          >
            <option value="" disabled>
              Select Donation Type
            </option>
            {dataType.map((item) => (
              <option key={item.id} value={item.id}>
                {item.name}
              </option>
            ))}
          </select>
        </div>

        <div className="flex flex-col space-y-2 ">
          <label className="font-medium text-black dark:text-gray-200">
            Donation Purpose
          </label>
          <select
            className="p-2 border border-gray-300 rounded-lg text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-400 focus:border-blue-500"
            value={purpose || ""}
            required
            onChange={(e) => setPurpose(e.target.value)}
          >
            <option value="" disabled>
              Select Donation Purpose
            </option>
            {filteredPurpose.map((item) => (
              <option key={item.id} value={item.id}>
                {item.name}
              </option>
            ))}
          </select>
        </div>

        <div className="flex justify-start mt-4">
          <button
            type="submit"
            className="bg-blue-500 text-white py-2 px-4 rounded-md hover:bg-blue-600 mr-4"
          >
            Save and Close
          </button>
          <button
            type="button"
            className="bg-blue-500 hover:bg-blue-600 text-white py-2 px-4 rounded-md"
            onClick={handleResetForm}
          >
            Cancel
          </button>
        </div>
      </form>
    </div>
  );
};
